module.exports = __webpack_public_path__ + "static/media/blue_nebula_DN.16cda86e.png";